// MuteContext.tsx
import React, { createContext, useContext, useState } from "react";

type PauseContextType = {
  isPaused: boolean;
  togglePaused: () => void;
  setPaused: (value: boolean) => void;
};

const PauseContext = createContext<PauseContextType | undefined>(undefined);

export const PauseProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isPaused, setIsPaused] = useState(false);

  const togglePaused = () => setIsPaused((prev) => !prev);
  const setPaused = (value: boolean) => setIsPaused(value);

  return (
    <PauseContext.Provider value={{ isPaused, togglePaused, setPaused }}>
      {children}
    </PauseContext.Provider>
  );
};

export const usePause = () => {
  const ctx = useContext(PauseContext);
  if (!ctx) throw new Error("usePause must be used inside PauseProvider");
  return ctx;
};
